import { createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/ReduxProvider/store';

export const getIdentityValidation = createSelector(
  (state: RootStateType) => state.identityValidation,
  (identityValidation) => identityValidation,
);
